"use client";

// Client-side ordstöd context for uppgiftstext (fraga-fält i Förståelse/
// Övning/Diagnos). Uppgiftstext bor i DB och renderas av klient-komponenter
// (InlineMath), till skillnad från Teori/Förkunskaper/Efter-avsnitt som
// markeras server-side via rehype-ordstod (se Site/src/lib/ordstod/). Samma
// gating (global kill-switch → elev-override → klass → på) beräknas
// server-side i page.tsx och skickas ner som denna serialiserbara payload —
// Map:ar kan inte korsa server/klient-gränsen så former/förklaring/kontext är
// plain Record-objekt här (InlineMath bygger en Map av `former` via useMemo).

import { createContext, useContext, type ReactNode } from "react";

export type OrdstodClientData = {
  former: Record<string, string>; // inflected form (lowercase) -> lemma
  forklaring: Record<string, string>; // lemma -> plain-language explanation
  kontext: Record<string, string>; // lemma -> delavsnitt-specific context line
} | null;

const OrdstodContext = createContext<OrdstodClientData>(null);

export function OrdstodProvider({
  value,
  children,
}: {
  value: OrdstodClientData;
  children: ReactNode;
}) {
  return (
    <OrdstodContext.Provider value={value}>{children}</OrdstodContext.Provider>
  );
}

// null = gating off (global kill-switch, elev/klass av, eller inget sidecar
// för delavsnittet) — konsumenter ska då inte markera något.
export function useOrdstod(): OrdstodClientData {
  return useContext(OrdstodContext);
}
